module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Medium.woff2";